import { connect } from 'react-redux';

import USEREDIT from '../../components/sider/useredit';

export default connect()(USEREDIT);



// WEBPACK FOOTER //
// ./containers/sider/useredit.js